// extracted by css-extract-rspack-plugin
export default {"resolvedCountLabel":"TypeGroup-module__resolvedCountLabel__Fg4dj"};